import { CampaignReleaseEarningsPartial } from "../../partials/menu/campaign/release-earnings.partial";

export default function CampaignReleaseEarningsScreen() {
  return <CampaignReleaseEarningsPartial />;
}
